export default {
  'pages.setting.dict.title': '字典管理',
  'pages.setting.dict.subtitle': '组织与管理公司字典',
  // 左侧 - 字典类型
  'pages.setting.dict.typeTitle': '字典类型',
  'pages.setting.dict.typeSearchPlaceholder': '搜索字典类型...',
  'pages.setting.dict.typeName': '类型名称',
  'pages.setting.dict.typeCode': '类型代码',
  // 右侧 - 字典项列
  'pages.setting.dict.column.label': '标签',
  'pages.setting.dict.column.value': '值',
  'pages.setting.dict.column.sort': '排序',
  'pages.setting.dict.column.status': '状态',
  'pages.setting.dict.column.operation': '操作',
  // 状态
  'pages.setting.dict.status.enabled': '启用',
  'pages.setting.dict.status.disabled': '禁用',
  // 操作
  'pages.setting.dict.addType': '新增字典类型',
  'pages.setting.dict.addItem': '新增字典项',
  'pages.setting.dict.edit': '编辑',
  // 弹窗标题
  'pages.setting.dict.modal.addTypeTitle': '新增字典类型',
  'pages.setting.dict.modal.editTypeTitle': '编辑字典类型',
  'pages.setting.dict.modal.addItemTitle': '新增字典项',
  'pages.setting.dict.modal.editItemTitle': '编辑字典项',
  // 字典类型表单
  'pages.setting.dict.form.dictName': '类型名称',
  'pages.setting.dict.form.dictNamePlaceholder': '请输入类型名称',
  'pages.setting.dict.form.dictNameRequired': '请输入类型名称',
  'pages.setting.dict.form.dictType': '类型代码',
  'pages.setting.dict.form.dictTypePlaceholder': '请输入类型代码',
  'pages.setting.dict.form.dictTypeRequired': '请输入类型代码',
  'pages.setting.dict.form.dictTypePattern': '类型代码只能包含字母、数字、下划线',
  'pages.setting.dict.form.status': '状态',
  'pages.setting.dict.form.statusRequired': '请选择状态',
  'pages.setting.dict.form.remark': '备注',
  'pages.setting.dict.form.remarkPlaceholder': '请输入备注',
  // 字典项表单
  'pages.setting.dict.form.dictLabel': '显示名称',
  'pages.setting.dict.form.dictLabelPlaceholder': '请输入显示名称',
  'pages.setting.dict.form.dictLabelRequired': '请输入显示名称',
  'pages.setting.dict.form.dictValue': '数据值',
  'pages.setting.dict.form.dictValuePlaceholder': '请输入数据值',
  'pages.setting.dict.form.dictValueRequired': '请输入数据值',
  'pages.setting.dict.form.dictSort': '排序',
  'pages.setting.dict.form.dictSortPlaceholder': '请输入排序号',
  'pages.setting.dict.form.description': '描述',
  'pages.setting.dict.form.descriptionPlaceholder': '请输入描述',
  // 提示消息
  'pages.setting.dict.message.deleteSuccess': '删除成功',
  'pages.setting.dict.message.addSuccess': '新增成功',
  'pages.setting.dict.message.addFailed': '新增失败',
  'pages.setting.dict.message.editSuccess': '编辑成功',
  'pages.setting.dict.message.editFailed': '编辑失败',
};
